import $ from 'jquery';
import { QueryClient } from 'react-query';

const defaultQueryFn = async ({ queryKey }) => {
    return $.ajax(queryKey[0]);
};

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            queryFn: defaultQueryFn
        }
    }
});
